<div class="flex flex-col items-end" [ngClass]="{ 'temporary-page': isPageTemporary }">
  <div class="flex justify-between w-full mb-2 md:!mb-4">
    <div>
      <a href="/assets" *ngIf="!isPageTemporary" class="hidden xl:flex gap-1 items-center">
        <i class="bi bi-chevron-left fa-md"></i>
        <span class="text-gray-90 text-base">
          {{ 'RegisterService::BackToAssets' | abpLocalization }}</span
        >
      </a>
    </div>
    <div
      *ngIf="asset && !isPageTemporary"
      class="flex w-full md:w-max gap-1 md:!gap-0 flex-wrap bg-white md:rounded-[8px] btn-container"
    >
      <button
        *abpPermission="'RegisterService.Requests.Match'"
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="showRequestModal = true"
      >
        {{ 'RegisterService::Match' | abpLocalization }}
      </button>
      <button
        *abpPermission="'RegisterService.Assets.Reserve'"
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 md:min-w-[70px]"
        (click)="onModalOpen('reserve')"
      >
        {{ 'RegisterService::Reserve' | abpLocalization }}
      </button>
      <button
        *abpPermission="'RegisterService.Assets.Move'"
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="onModalOpen('move')"
      >
        {{ 'RegisterService::Move' | abpLocalization }}
      </button>
      <ng-container *ngIf="!isPageTemporary">
        <button
          *abpPermission="'RegisterService.Assets.Checkout'"
          type="button"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
          (click)="onModalOpen('checkout')"
        >
          {{ 'RegisterService::Checkout' | abpLocalization }}
        </button>
      </ng-container>
      <ng-container *ngIf="!isPageTemporary && asset">
        <button
          *abpPermission="'RegisterService.Assets.Allocate'"
          type="button"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
          (click)="onModalOpen('allocate')"
          [disabled]="asset.isDeallocated"
        >
          {{ 'RegisterService::Allocate' | abpLocalization }}
        </button>
      </ng-container>
      <div *abpPermission="'RegisterService.Assets.Deallocate'">
        <button
          type="button"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
          (click)="onModalOpen('deallocate')"
          [disabled]="(asset?.jobsiteIds?.length ?? 0) === 0"
          *ngIf="asset && asset.assetType === assetType.OWNED && !asset.isDeallocated"
        >
          {{ 'RegisterService::Deallocate' | abpLocalization }}
        </button>
      </div>
      <div
        *abpPermission="'RegisterService.Assets.Collect'"
        [ngStyle]="{
          display:
            asset?.assetType === assetType.OWNED && (asset?.isDeallocated ?? false)
              ? 'block'
              : 'none'
        }"
      >
        <button
          type="button"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
          (click)="collectAsset(asset)"
          *ngIf="asset?.assetType === assetType.OWNED && (asset?.isDeallocated ?? false)"
        >
          {{ 'RegisterService::Collect' | abpLocalization }}
        </button>
      </div>
      <div
        *abpPermission="'RegisterService.Assets.OffHire'"
        [ngStyle]="{ display: asset?.assetType === assetType.HIRED ? 'block' : 'none' }"
      >
        <button
          type="button"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
          (click)="offHireAsset(asset)"
          *ngIf="asset?.assetType === assetType.HIRED"
        >
          {{ 'RegisterService::OffHire' | abpLocalization }}
        </button>
      </div>
      <button
        *abpPermission="'RegisterService.Assets.ToggleActivity'"
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="onModalOpen('status')"
      >
        {{ 'RegisterService::ActiveStatus' | abpLocalization }}
      </button>
      <ng-container *ngIf="asset?.isActive">
        <a
          *abpPermission="'RegisterService.Assets.Edit'"
          [routerLink]="['/assets/edit', asset.id]"
          class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        >
          {{ 'AbpUi::Edit' | abpLocalization }}
        </a>
        <ng-container *ngIf="!isPageTemporary">
          <button
            *abpPermission="'ServicingService.Events.Create'"
            class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
            (click)="onInspect()"
          >
            {{ 'RegisterService::Event' | abpLocalization }}
          </button>
        </ng-container>
      </ng-container>
      <button
        *abpPermission="'RegisterService.Assets.Delete'"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="onDelete()"
      >
        <i class="fa fa-thrash-alt"></i>
        {{ '::Delete' | abpLocalization }}
      </button>
    </div>
    <div
      *ngIf="isPageTemporary"
      class="flex w-full md:w-max gap-1 md:!gap-0 flex-wrap bg-white md:rounded-[8px] btn-container mb-2 md:!mb-4"
    >
      <button
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="isStaffActionModalOpen = true; staffActionType = 'checkout'"
      >
        {{ 'RegisterService::Checkout' | abpLocalization }}
      </button>
      <button
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="isStaffActionModalOpen = true; staffActionType = 'event'"
      >
        {{ 'RegisterService::Event' | abpLocalization }}
      </button>
      <button
        type="button"
        class="border hover:bg-gray-20 flex-center border-gray-20 text-gray-60 !p-2 lg:min-w-[70px]"
        (click)="isStaffActionModalOpen = true; staffActionType = 'allocate'"
        [disabled]="asset?.isDeallocated"
      >
        {{ 'RegisterService::Allocate' | abpLocalization }}
      </button>
    </div>
  </div>
  <div *ngIf="asset" class="w-full">
    <app-asset-infos
      [asset]="asset"
      [isPageTemporary]="isPageTemporary"
      [tenantPassword]="tenantPassword"
      *ngIf="isPageTemporary"
    ></app-asset-infos>
    <div *ngIf="!isPageTemporary">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3 w-fit">
        <li [ngbNavItem]="1" class="ms-3 link-buttons">
          <a ngbNavLink>{{ '::Information' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-asset-infos [asset]="asset"></app-asset-infos>
          </ng-template>
        </li>
        <li [ngbNavItem]="2" class="ms-3 link-buttons">
          <a ngbNavLink>{{ 'RegisterService::EventHistory' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-asset-details-event-history
              [asset]="asset"
              [isGroup]="true"
              [isPageTemporary]="isPageTemporary"
            ></app-asset-details-event-history>
          </ng-template>
        </li>
        <li [ngbNavItem]="3" class="ms-3 link-buttons">
          <a ngbNavLink>{{ 'RegisterService::TransferHistory' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-asset-details-transfer-history
              [asset]="asset"
              [isGroup]="true"
            ></app-asset-details-transfer-history>
          </ng-template>
        </li>
        <li [ngbNavItem]="4" class="ms-3 link-buttons">
          <a ngbNavLink>{{ '::Documents' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-attachment
              apiName="registerService"
              attachedToEntity="assets"
              ownerType="Asset"
              [attachedToId]="asset.id"
            ></app-attachment>
            <h4 class="mt-3 border-bottom">
              {{ 'RegisterService::RelativeDocuments' | abpLocalization }}
            </h4>
            <app-attachment
              apiName="registerService"
              attachedToEntity="categories"
              ownerType="Category"
              [attachedToId]="asset.categoryId"
              [allowAttach]="false"
              [allowDelete]="false"
            ></app-attachment>
          </ng-template>
        </li>

        <li [ngbNavItem]="5" class="ms-3 link-buttons">
          <a ngbNavLink>{{ 'RegisterService::Utilization' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-asset-utilization [asset]="asset"></app-asset-utilization>
          </ng-template>
        </li>

        <li [ngbNavItem]="6" class="ms-3 link-buttons">
          <a ngbNavLink>{{ 'RegisterService::Trackers' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-asset-trackers [assetDetails]="asset"></app-asset-trackers>
          </ng-template>
        </li>

        <li [ngbNavItem]="7" *ngIf="asset.hasSubAssets" class="ms-3 link-buttons">
          <a ngbNavLink>{{ 'RegisterService::SubAssets' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-sub-assets [asset]="asset"></app-sub-assets>
          </ng-template>
        </li>
        <li [ngbNavItem]="8" class="ms-3 link-buttons">
          <a ngbNavLink> {{ 'RegisterService::Financial' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <app-financial-tab [asset]="asset"></app-financial-tab>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
</div>

<app-queue-modals
  *ngIf="isModalOpen"
  [type]="modalType"
  [asset]="asset"
  [isModalOpen]="isModalOpen"
  [isGuest]="isPageTemporary"
  [pinOrKeyringPassword]="pinOrKeyringPassword"
  (modalClose)="onModalClose()"
></app-queue-modals>

<app-request-picker
  *ngIf="showRequestModal"
  [assetId]="asset.id"
  [isPageTemporary]="isPageTemporary"
  [tenantName]="tenantName"
  [pinOrKeyringPassword]="pinOrKeyringPassword"
  [categoryId]="asset.categoryId"
  [openModal]="showRequestModal"
  (modalClose)="onRequestSubmit()"
></app-request-picker>

<abp-modal
  *ngIf="isPageTemporary"
  [(visible)]="isTemporaryModalOpen"
  [options]="{
    animation: true,
    centered: true,
    backdropClass: 'hidenContent',
    keyboard: false,
    backdrop: 'static'
  }"
>
  <ng-template #abpHeader>
    <h3 class="modal-header p-0 m-0">
      {{ 'RegisterService::TenantPassword' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <div class="mb-3 d-flex flex-column gap-3 align-items-center justify-content-center">
      <div class="w-100">
        <label
          class="form-label"
          for="tenant-password"
          *ngIf="wrongTenantPassword"
          class="text-danger"
          >{{ 'RegisterService::IncorrectTenantPassword' | abpLocalization }}</label
        >
        <input
          [(ngModel)]="tenantPassword"
          [ngClass]="{ 'wrong-input': wrongTenantPassword }"
          class="form-control"
          id="tenant-password"
          maxlength="64"
        />
      </div>
      <abp-button [disabled]="!tenantPassword" (click)="checkIfPasswordIsCorrect()">
        {{ 'AbpUi::Submit' | abpLocalization }}
      </abp-button>
    </div>
  </ng-template>
</abp-modal>
<abp-modal
  [(visible)]="isStaffActionModalOpen"
  [options]="{
    animation: true,
    centered: true,
  }"
  (appear)="pinOrKeyringPassword = ''"
>
  <ng-template #abpHeader>
    <h3 class="modal-header m-0 p-0">
      {{ 'RegisterService::PinOrPassword' | abpLocalization }}
    </h3>
  </ng-template>
  <ng-template #abpBody>
    <div class="mb-3 d-flex gap-2 align-items-end justify-content-between">
      <label
        class="form-label"
        for="tenant-password"
        *ngIf="wrongPinOrPassword"
        class="text-danger"
        >{{ 'RegisterService::IncorrectPinOrPassword' | abpLocalization }}</label
      >
      <input
        (input)="onPinInput($event)"
        [(ngModel)]="pinOrKeyringPassword"
        [ngClass]="{ 'wrong-input': wrongPinOrPassword }"
        class="form-control"
        id="pin-or-password"
      />
      <!-- <button class="btn btn-primary qr-button" (click)="isQRScannerShown = true">
        <i class="fa fa-qrcode fa-2x"></i>
      </button> -->
    </div>
    <!-- <zxing-scanner *ngIf="isQRScannerShown" (scanSuccess)="onScanSuccess($event)"></zxing-scanner> -->
  </ng-template>
</abp-modal>
